import PropTypes from 'prop-types'

export const ResolverPropType = PropTypes.shape({
  name: PropTypes.string.isRequired,
  revenue: PropTypes.number,
  cases: PropTypes.number,
})
